import { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import '../../business/components/CartModal.css'
import './InsufficientStockModal.css'

function InsufficientStockModal({ isOpen, items, onClose }) {
  const navigate = useNavigate()
  const { business } = useParams()

  useEffect(() => {
    if (!isOpen) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, onClose])

  const goToBusiness = () => {
    onClose?.()
    if (business) {
      navigate(`/${encodeURIComponent(business)}`)
      return
    }
    navigate('/')
  }

  const list = useMemo(() => (Array.isArray(items) ? items : []), [items])

  if (!isOpen) return null

  return (
    <div className="cart-modal-overlay" onMouseDown={() => onClose?.()} role="presentation">
      <div
        className="cart-modal insufficient-stock-modal"
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Недостаточно товаров"
      >
        <div className="cart-modal-header">
          <div className="cart-modal-title">
            Недостаточно на складе
            <span className="cart-modal-subtitle">
              {list.length
                ? `${list.length} ${list.length === 1 ? 'товар' : list.length >= 2 && list.length <= 4 ? 'товара' : 'товаров'}`
                : 'Нет данных'}
            </span>
          </div>
          <button
            className="cart-modal-close"
            type="button"
            onClick={() => onClose?.()}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>

        <div className="cart-modal-body">
          {list.length === 0 ? (
            <div className="cart-modal-empty">Нет товаров с нехваткой.</div>
          ) : (
            <ul className="cart-modal-list">
              {list.map((it) => {
                const key = it.key ?? it.id
                const needed = Number(it.needed ?? it.quantity ?? 0)
                const available = Number(it.available ?? 0)
                return (
                  <li key={key} className="cart-modal-item">
                    <div className="cart-modal-item-left">
                      {it.image ? (
                        <img className="cart-modal-item-image" src={it.image} alt={it.name || ''} />
                      ) : (
                        <div className="cart-modal-item-image cart-modal-item-image--placeholder" />
                      )}
                      <div className="cart-modal-item-meta">
                        <div className="cart-modal-item-name">{it.name || 'Товар'}</div>
                        <div className="insufficient-stock-meta">
                          нужно: {needed} · в наличии: {available < 0 ? 0 : available}
                        </div>
                      </div>
                    </div>
                    <div className="cart-modal-item-right">
                      <div
                        className="cart-modal-qty-pill insufficient-stock-qty"
                        aria-label={`Нужно ${needed}`}
                      >
                        × {needed}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>

        <div className="cart-modal-footer">
          <div className="cart-modal-footer-actions">
            <button
              className="cart-modal-buyBtn"
              type="button"
              onClick={goToBusiness}
              style={{ backgroundColor: '#242424' }}
            >
              Назад в бизнес
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InsufficientStockModal
